// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wide":"(min-width:1600px)","serif":"fonts__serif___8JVKh","sans":"fonts__sans___1IZhO","sansBold":"fonts__sansBold___1u-Eg","easeInOutQuad":"cubic-bezier(.455,.03,.515,.955)","tr":"archiverow__tr___qfyMA","td":"archiverow__td___3h5R- fonts__sansBold___1u-Eg","text":"archiverow__text___1Ar8i fonts__sans___1IZhO","link":"archiverow__link___OuQTf type__linkTransition___QZ_bD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArchiveRow/archiverow.css
// module id = 153
// module chunks = 0